/*
 * Copyright, AlpineReplay, Inc. 2021. All rights reserved.
 * Author: Slobodan Djordjevic
 */
import React from "react"
import {
    TitleSection,
    ModalTitle,
    ContentSection,
    Label,
    Stack,
    Button,
    Element,
} from "trux"

export const InAppSurveyContent = ({ onRate, onClose, activeSurvey }) => {

    return (
        <>
            <TitleSection onCloseClick={onClose}>
                <ModalTitle content="Give your feedback!" />
            </TitleSection>
            <ContentSection>
                <Label
                    type={Label.Type.Body}
                    marginBottom="8"
                    center
                    bold
                    content={activeSurvey.question}
                />
                <Stack
                    className="rate-buttons"
                    xs={Stack.Type.Column}
                    sm={Stack.Type.Column}
                    md={Stack.Type.Row}
                    lg={Stack.Type.Row}
                    span="12"
                    marginBottom="4"
                    justifyContent={"stretch"}
                >
                    {activeSurvey.answers?.map((rating) => (
                        <Button
                            small
                            spanLG="1"
                            spanMD="1"
                            spanSM="12"
                            spanXS="12"
                            key={`rate-button-${rating.detail_id}`}
                            trkAction={`rate-button-${rating.title}`}
                            onClick={(e) => onRate(rating.detail_id)}
                            content={
                                <>
                                    {rating.title}
                                </>
                            }
                            margin="2 1"
                        />
                    ))}
                </Stack>
            </ContentSection>
        </>
    )
}